import { network } from 'services/network';

export const deleteDataStory = (id) => {
    const url = `api/bo/project/deleteDataStory?id=${id}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
